import React from 'react'
import { withFormsy } from 'formsy-react'

import FieldError from './../FieldError'
import { parseHtml } from '../../../util/parse-html'
import withBaseFormsy from './withBaseFormsy'

class CheckBox extends withBaseFormsy(React.Component) {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue(event, checkedItem) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.

    this.setValue(event)
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const item = this.props.item || {}

    if(this.props.getValue() === undefined)
      return null

    return (
      <div className={this.props.className}>
        <label htmlFor={`input_${item.id}`}>
          {item.name}
        </label>
        <div className="form-inline checkbox-form">
          {Object.keys(item.format.checkbox).map((label, index) =>
            <div className="form-check col-md-6" key={label} style={{padding: 0, justifyContent:"flex-start"}}>
              <input
                onChange={(e) => this.changeValue(e, label)}
                onClick={this.props.onClick}
                value={label}
                placeholder={this.props.placeholder}
                id={`${item.id}_${index}`}
                className={`form-control ${errorMessage ? "has-error" : ""}`}
                type="checkbox"
                name={this.props.name}
                style={{height: "auto", width: "auto", marginRight: "4px", marginBottom: "2px"}}
                checked={this.props.getValue().checkbox[label]}
              />
              <label className="form-check-label" htmlFor={`${item.id}_${index}`} style={{paddingLeft: "4px", cursor: "pointer"}}>{label}</label>
            </div>
          )}
        </div>
        { errorMessage && <FieldError message={errorMessage} /> }
        { errorMessage && <br/>}
        {parseHtml(item.note)}
      </div>
    );
  }
}

export default withFormsy(CheckBox);
